// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dynamic-campaign-form {
    display: flex;
    flex-direction: column;
    gap: 20px;
    max-width: 800px;
    margin: 0 auto;
    margin-bottom: 30px;
    border: 1px solid #ddd;
    border-radius: 5px;
    padding: 20px;
    background-color: #fff;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
}

/* ==========Message Note Style========= */
.quick-input-row {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%; 
}

.quick-input-row .quick-input-field {
  flex: 1 1;              
}

.quick-input-row select {
  width: 100%;          
}

.mapping-arrow {
  font-size: 20px;
  font-weight: 600;
  color: #373435;
}

.quick-input-field .input-alert-combine {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .quick-input-field .select-mobile-number-alert {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .quick-input-field .select-mobile-number-alert small {
    color: red;
    font-size: 12px;
    text-align: start;
  }
  
  .quick-input-field small {
    color: #373435;
    font-size: 12px;
    text-align: start;
  }

.dynamic-input-field input {
    width: auto;
}

.dynamic-input-field label {
    flex: 0 0 200px; /* Set a fixed width for all labels */
    text-align: left; /* Align label text to the left */
    font-weight: bold;
}

.dynamic-input-field input[type="text"],
.dynamic-input-field select,
.dynamic-input-field textarea {
    flex: 1 1; /* Take up remaining space */
    padding: 8px;
    font-size: 14px;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-sizing: border-box;
}

.dynamic-input-field textarea {
    resize: vertical; /* Allow vertical resizing */
}

.quick-input-field input {
    margin: 0;
}

/* Code for search select dropdown menu  options */
.custom-react-select {
  flex: 1 1;
  width: 100%;
}

.custom-react-select .custom-select__control {
  width: 100%;
  padding: 2px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  min-height: 38px;
  box-shadow: none;
  text-align: left;
}

/* Set the placeholder text to black and left aligned */
.custom-react-select .custom-select__placeholder {
  color: black;
  text-align: left;
  margin-left: 0;
}

.custom-react-select.search-mode .custom-select__placeholder {
  color: #aaa !important; /* light grey */
}

/* Set the selected value text to black */
.custom-react-select .custom-select__single-value {
  color: black;
  text-align: left;
}

/* Make dropdown menu options black */
.custom-react-select .custom-select__option {
  font-size: 14px;
  padding: 8px 12px;
  color: black;
  text-align: left;
}

/* Style focused option */
.custom-react-select .custom-select__option--is-focused {
  background-color: #f0f0f0;
  color: black;
}

/* Style selected option */
.custom-react-select .custom-select__option--is-selected {
  background-color: #007bff;
  color: white;
}

/* Remove yellow box shadow on focus */
.custom-react-select .custom-select__control--is-focused {
  box-shadow: none !important;
  border-color: #ccc !important; /* Optional: set to your default border */
}

/* Also handle hover state if needed */
.custom-react-select .custom-select__control:hover {
  border-color: #ccc;
}

/* Optional: remove default browser highlight on input */
.custom-react-select input:focus {
  outline: none;
  box-shadow: none !important;
}
/* Code for search select dropdown menu  options */

/* Dynamic Buttons */
.dynamic-form-buttons .btn-preview {
    color: #fff;
    background-color: #44a67e;
    border: 1px solid #44a67e;
    padding: 10px 20px;
    border-radius: 5px;
    cursor: pointer;
    margin-top: -10px;
}


/* Preview Table */
.numeric-details {
    display: flex;
    flex-direction: row;
    background-color: #fefefe;
    color: #373435;
    margin-top: 5px;
}
  

/* Button Style */

.dynamic-campaign-buttons-wrap {
    font-size: 0.9em;
    margin: 0 !important;
    color: #333;
    text-align: end;
}

.dynamic-campaign-button {
    color: #fff;
    background-color: #44a67e;
    border: 1px solid #44a67e;
    padding: 10px 20px;
    border-radius: 5px;
    cursor: pointer;
    margin-top: -10px;
  }

  .dynamic-campaign-button:disabled {
    background-color: #a9a9a9;
    border-color: #a9a9a9;
    cursor: not-allowed;
  }

  .split-input-container {
    display: flex;
    align-items: center;
    gap: 1rem;
    flex-wrap: wrap;
    justify-content: end;
    width: 100%;
  }

  .split-file-rows {
    display: flex;
    flex-direction: row !important;
    justify-content: end;
    align-items: end;
    gap: 1rem;
    width: 100%;
}

.split-input-rows button.remove-row-btn {
    background-color: #ff4d4f;
    color: white;
    border: none;
    border-radius: 4px;
    padding: 0.5rem 1rem;
    cursor: pointer;
    height: 38px;
    margin-right: -11px;
  }
  
  .split-input-rows button.remove-row-btn:hover {
    background-color: #d9363e;
  }

  .dynamicWrapHourTime {
    display: flex;
    width: 35%;
    gap: 10%;
  }
  
  .dynamicWrapHourTime .hourAndMinute{
    padding: 0.75rem;
  }


  .preview-table-container {
    max-height: 350px; /* Set your desired height */
    overflow-y: auto;
    border: 1px solid #ddd;
  }
  
  .preview-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;
    margin-bottom: 15px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  }
  
  .preview-table thead {
    background-color: #ffcc29;
    color: white;
  }
  
  .preview-table th, .preview-table td {
    padding: 12px 15px;
    text-align: left;
    border: 1px solid #ddd;
    color: #373435;
  }
  
  .preview-table tbody tr:nth-child(even) {
    background-color: #f9f9f9;
  }
  
  .preview-table tbody tr:hover {
    background-color: #f1f1f1;
  }
  
  .preview-table th {
    font-weight: 650;
  }
  
  /* Overlay with blur */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  backdrop-filter: blur(6px);
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

/* Modal Box */
.modal-box {
  background: #fff;
  padding: 25px 30px;
  border-radius: 10px;
  text-align: center;
  width: 370px;
  box-shadow: 0 8px 20px rgba(0,0,0,0.2);
  animation: fadeIn 0.3s ease-in-out;
}

/* Text */
.modal-box p {
  margin-bottom: 20px;
  font-size: 16px;
  font-weight: 500;
  color: #373435;
  line-height: 1.2;
}

/* Button */
.modal-box button {
  padding: 8px 20px;
  border: none;
  background-color: #fb3d4e;
  color: #fff;
  border-radius: 5px;
  cursor: pointer;
}

.modal-box button:hover {
  background-color: #fb3d4e;
}

/* Animation */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
} 

/* SAMPLE FORMAT STYLE */

.sample-link {
  color: #373435;
  cursor: pointer;
  text-decoration: underline;
}

/* Overlay */
.sample-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}

/* Modal Box */
.sample-modal {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  width: 60%;
  max-height: 80%;
  overflow: auto;
  position: relative;
}

.sample-modal h4 {
  color: #373435;
}

/* Close Button */
.close-btn {
  position: absolute;
  top: 10px;
  right: 15px;
  font-size: 30px;
  cursor: pointer;
  color: red;
}

.sample-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #ddd; 
}

/* Header */
.sample-table th {
  border: 1px solid #ddd;
  padding: 8px;
  background: #f5f5f5;
  text-align: left;
  font-weight: 600;
  color: #373435;
}

/* Cells */
.sample-table td {
  border: 1px solid #ddd; 
  padding: 8px;
  font-size: 13px;
  color: #373435;
  text-align: left;
}

.sample-table tr {
  border-bottom: 1px solid #ddd;
}

/* Optional: last row fix */
.sample-table tr:last-child {
  border-bottom: none;
}


.reset-files-btn {
  padding: 8px 12px;
  border: none;
  background-color: #dc3545;
  color: #fff;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
}

.reset-files-btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/components/DynamicCampaign/DynamicCampaign.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,0CAA0C;AAC9C;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,UAAU;IACV,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,iBAAiB;EACnB;;AAEF;IACI,WAAW;AACf;;AAEA;IACI,eAAe,EAAE,qCAAqC;IACtD,gBAAgB,EAAE,iCAAiC;IACnD,iBAAiB;AACrB;;AAEA;;;IAGI,SAAO,EAAE,4BAA4B;IACrC,YAAY;IACZ,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB,EAAE,4BAA4B;AAClD;;AAEA;IACI,SAAS;AACb;;AAEA,kDAAkD;AAClD;EACE,SAAO;EACP,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,uDAAuD;AACvD;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,sBAAsB,EAAE,eAAe;AACzC;;AAEA,yCAAyC;AACzC;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA,qCAAqC;AACrC;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA,sCAAsC;AACtC;EACE,2BAA2B;EAC3B,6BAA6B,EAAE,yCAAyC;AAC1E;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;AACpB;;AAEA,wDAAwD;AACxD;EACE,aAAa;EACb,2BAA2B;AAC7B;AACA,kDAAkD;;AAElD,oBAAoB;AACpB;IACI,WAAW;IACX,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;;;AAGA,kBAAkB;AAClB;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,eAAe;AACnB;;;AAGA,iBAAiB;;AAEjB;IACI,gBAAgB;IAChB,oBAAoB;IACpB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;IACzB,qBAAqB;IACrB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,oBAAoB;IACpB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,oBAAoB;IACpB,gBAAgB;IAChB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,UAAU;IACV,QAAQ;EACV;;EAEA;IACE,gBAAgB;EAClB;;;EAGA;IACE,iBAAiB,EAAE,4BAA4B;IAC/C,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB;IACnB,0CAA0C;EAC5C;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,cAAc;EAChB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;EAClB;;EAEA,sBAAsB;AACxB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA,cAAc;AACd;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,sCAAsC;EACtC,kCAAkC;AACpC;;AAEA,SAAS;AACT;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,cAAc;AACd;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA,wBAAwB;;AAExB;EACE,cAAc;EACd,eAAe;EACf,0BAA0B;AAC5B;;AAEA,YAAY;AACZ;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA,cAAc;AACd;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,WAAW;AACX;EACE,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;AACrB;;;AAGA;EACE,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB","sourcesContent":[".dynamic-campaign-form {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 20px;\r\n    max-width: 800px;\r\n    margin: 0 auto;\r\n    margin-bottom: 30px;\r\n    border: 1px solid #ddd;\r\n    border-radius: 5px;\r\n    padding: 20px;\r\n    background-color: #fff;\r\n    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n/* ==========Message Note Style========= */\r\n.quick-input-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  width: 100%; \r\n}\r\n\r\n.quick-input-row .quick-input-field {\r\n  flex: 1;              \r\n}\r\n\r\n.quick-input-row select {\r\n  width: 100%;          \r\n}\r\n\r\n.mapping-arrow {\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  color: #373435;\r\n}\r\n\r\n.quick-input-field .input-alert-combine {\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 100%;\r\n  }\r\n\r\n  .quick-input-field .select-mobile-number-alert {\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 100%;\r\n  }\r\n\r\n  .quick-input-field .select-mobile-number-alert small {\r\n    color: red;\r\n    font-size: 12px;\r\n    text-align: start;\r\n  }\r\n  \r\n  .quick-input-field small {\r\n    color: #373435;\r\n    font-size: 12px;\r\n    text-align: start;\r\n  }\r\n\r\n.dynamic-input-field input {\r\n    width: auto;\r\n}\r\n\r\n.dynamic-input-field label {\r\n    flex: 0 0 200px; /* Set a fixed width for all labels */\r\n    text-align: left; /* Align label text to the left */\r\n    font-weight: bold;\r\n}\r\n\r\n.dynamic-input-field input[type=\"text\"],\r\n.dynamic-input-field select,\r\n.dynamic-input-field textarea {\r\n    flex: 1; /* Take up remaining space */\r\n    padding: 8px;\r\n    font-size: 14px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 4px;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.dynamic-input-field textarea {\r\n    resize: vertical; /* Allow vertical resizing */\r\n}\r\n\r\n.quick-input-field input {\r\n    margin: 0;\r\n}\r\n\r\n/* Code for search select dropdown menu  options */\r\n.custom-react-select {\r\n  flex: 1;\r\n  width: 100%;\r\n}\r\n\r\n.custom-react-select .custom-select__control {\r\n  width: 100%;\r\n  padding: 2px;\r\n  font-size: 14px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  box-sizing: border-box;\r\n  min-height: 38px;\r\n  box-shadow: none;\r\n  text-align: left;\r\n}\r\n\r\n/* Set the placeholder text to black and left aligned */\r\n.custom-react-select .custom-select__placeholder {\r\n  color: black;\r\n  text-align: left;\r\n  margin-left: 0;\r\n}\r\n\r\n.custom-react-select.search-mode .custom-select__placeholder {\r\n  color: #aaa !important; /* light grey */\r\n}\r\n\r\n/* Set the selected value text to black */\r\n.custom-react-select .custom-select__single-value {\r\n  color: black;\r\n  text-align: left;\r\n}\r\n\r\n/* Make dropdown menu options black */\r\n.custom-react-select .custom-select__option {\r\n  font-size: 14px;\r\n  padding: 8px 12px;\r\n  color: black;\r\n  text-align: left;\r\n}\r\n\r\n/* Style focused option */\r\n.custom-react-select .custom-select__option--is-focused {\r\n  background-color: #f0f0f0;\r\n  color: black;\r\n}\r\n\r\n/* Style selected option */\r\n.custom-react-select .custom-select__option--is-selected {\r\n  background-color: #007bff;\r\n  color: white;\r\n}\r\n\r\n/* Remove yellow box shadow on focus */\r\n.custom-react-select .custom-select__control--is-focused {\r\n  box-shadow: none !important;\r\n  border-color: #ccc !important; /* Optional: set to your default border */\r\n}\r\n\r\n/* Also handle hover state if needed */\r\n.custom-react-select .custom-select__control:hover {\r\n  border-color: #ccc;\r\n}\r\n\r\n/* Optional: remove default browser highlight on input */\r\n.custom-react-select input:focus {\r\n  outline: none;\r\n  box-shadow: none !important;\r\n}\r\n/* Code for search select dropdown menu  options */\r\n\r\n/* Dynamic Buttons */\r\n.dynamic-form-buttons .btn-preview {\r\n    color: #fff;\r\n    background-color: #44a67e;\r\n    border: 1px solid #44a67e;\r\n    padding: 10px 20px;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    margin-top: -10px;\r\n}\r\n\r\n\r\n/* Preview Table */\r\n.numeric-details {\r\n    display: flex;\r\n    flex-direction: row;\r\n    background-color: #fefefe;\r\n    color: #373435;\r\n    margin-top: 5px;\r\n}\r\n  \r\n\r\n/* Button Style */\r\n\r\n.dynamic-campaign-buttons-wrap {\r\n    font-size: 0.9em;\r\n    margin: 0 !important;\r\n    color: #333;\r\n    text-align: end;\r\n}\r\n\r\n.dynamic-campaign-button {\r\n    color: #fff;\r\n    background-color: #44a67e;\r\n    border: 1px solid #44a67e;\r\n    padding: 10px 20px;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    margin-top: -10px;\r\n  }\r\n\r\n  .dynamic-campaign-button:disabled {\r\n    background-color: #a9a9a9;\r\n    border-color: #a9a9a9;\r\n    cursor: not-allowed;\r\n  }\r\n\r\n  .split-input-container {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 1rem;\r\n    flex-wrap: wrap;\r\n    justify-content: end;\r\n    width: 100%;\r\n  }\r\n\r\n  .split-file-rows {\r\n    display: flex;\r\n    flex-direction: row !important;\r\n    justify-content: end;\r\n    align-items: end;\r\n    gap: 1rem;\r\n    width: 100%;\r\n}\r\n\r\n.split-input-rows button.remove-row-btn {\r\n    background-color: #ff4d4f;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 4px;\r\n    padding: 0.5rem 1rem;\r\n    cursor: pointer;\r\n    height: 38px;\r\n    margin-right: -11px;\r\n  }\r\n  \r\n  .split-input-rows button.remove-row-btn:hover {\r\n    background-color: #d9363e;\r\n  }\r\n\r\n  .dynamicWrapHourTime {\r\n    display: flex;\r\n    width: 35%;\r\n    gap: 10%;\r\n  }\r\n  \r\n  .dynamicWrapHourTime .hourAndMinute{\r\n    padding: 0.75rem;\r\n  }\r\n\r\n\r\n  .preview-table-container {\r\n    max-height: 350px; /* Set your desired height */\r\n    overflow-y: auto;\r\n    border: 1px solid #ddd;\r\n  }\r\n  \r\n  .preview-table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    margin-top: 20px;\r\n    margin-bottom: 15px;\r\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\r\n  }\r\n  \r\n  .preview-table thead {\r\n    background-color: #ffcc29;\r\n    color: white;\r\n  }\r\n  \r\n  .preview-table th, .preview-table td {\r\n    padding: 12px 15px;\r\n    text-align: left;\r\n    border: 1px solid #ddd;\r\n    color: #373435;\r\n  }\r\n  \r\n  .preview-table tbody tr:nth-child(even) {\r\n    background-color: #f9f9f9;\r\n  }\r\n  \r\n  .preview-table tbody tr:hover {\r\n    background-color: #f1f1f1;\r\n  }\r\n  \r\n  .preview-table th {\r\n    font-weight: 650;\r\n  }\r\n  \r\n  /* Overlay with blur */\r\n.modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  backdrop-filter: blur(6px);\r\n  background: rgba(0, 0, 0, 0.3);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 9999;\r\n}\r\n\r\n/* Modal Box */\r\n.modal-box {\r\n  background: #fff;\r\n  padding: 25px 30px;\r\n  border-radius: 10px;\r\n  text-align: center;\r\n  width: 370px;\r\n  box-shadow: 0 8px 20px rgba(0,0,0,0.2);\r\n  animation: fadeIn 0.3s ease-in-out;\r\n}\r\n\r\n/* Text */\r\n.modal-box p {\r\n  margin-bottom: 20px;\r\n  font-size: 16px;\r\n  font-weight: 500;\r\n  color: #373435;\r\n  line-height: 1.2;\r\n}\r\n\r\n/* Button */\r\n.modal-box button {\r\n  padding: 8px 20px;\r\n  border: none;\r\n  background-color: #fb3d4e;\r\n  color: #fff;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n}\r\n\r\n.modal-box button:hover {\r\n  background-color: #fb3d4e;\r\n}\r\n\r\n/* Animation */\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: scale(0.9);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: scale(1);\r\n  }\r\n} \r\n\r\n/* SAMPLE FORMAT STYLE */\r\n\r\n.sample-link {\r\n  color: #373435;\r\n  cursor: pointer;\r\n  text-decoration: underline;\r\n}\r\n\r\n/* Overlay */\r\n.sample-modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: rgba(0,0,0,0.5);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 2000;\r\n}\r\n\r\n/* Modal Box */\r\n.sample-modal {\r\n  background: #fff;\r\n  padding: 20px;\r\n  border-radius: 8px;\r\n  width: 60%;\r\n  max-height: 80%;\r\n  overflow: auto;\r\n  position: relative;\r\n}\r\n\r\n.sample-modal h4 {\r\n  color: #373435;\r\n}\r\n\r\n/* Close Button */\r\n.close-btn {\r\n  position: absolute;\r\n  top: 10px;\r\n  right: 15px;\r\n  font-size: 30px;\r\n  cursor: pointer;\r\n  color: red;\r\n}\r\n\r\n.sample-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  border: 1px solid #ddd; \r\n}\r\n\r\n/* Header */\r\n.sample-table th {\r\n  border: 1px solid #ddd;\r\n  padding: 8px;\r\n  background: #f5f5f5;\r\n  text-align: left;\r\n  font-weight: 600;\r\n  color: #373435;\r\n}\r\n\r\n/* Cells */\r\n.sample-table td {\r\n  border: 1px solid #ddd; \r\n  padding: 8px;\r\n  font-size: 13px;\r\n  color: #373435;\r\n  text-align: left;\r\n}\r\n\r\n.sample-table tr {\r\n  border-bottom: 1px solid #ddd;\r\n}\r\n\r\n/* Optional: last row fix */\r\n.sample-table tr:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n\r\n.reset-files-btn {\r\n  padding: 8px 12px;\r\n  border: none;\r\n  background-color: #dc3545;\r\n  color: #fff;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-size: 13px;\r\n}\r\n\r\n.reset-files-btn:disabled {\r\n  background-color: #ccc;\r\n  cursor: not-allowed;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
